export type ActionType =
  | 'SET_TICKET_DATA'
  | 'REQUEST_TICKET_DATA'
  | 'RECEIVED_TICKET_DATA'
  | 'ERROR_TICKET_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialBudgetState = {
  isFetching: true,
  data: {},
  error: {},
};

const Ticket = (state = initialBudgetState, action: Partial<ActionProps>) => {
  switch (action.type) {
    case 'REQUEST_TICKET_DATA': {
      return {
        ...state,
      };
    }

    case 'RECEIVED_TICKET_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_TICKET_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default Ticket;
